var oTooltip; // global !!!!!!!!!!!

document.addEventListener('click', () => {
    if (oTooltip && !oTooltip.classList.contains('hidden')) {

        setTimeout(() => {
            if (oTooltip) {
                oTooltip.remove();
                oTooltip = '';
            }
        }, 0);

    }
});

function fCreateTooltip(event) {

    //let isTouch = ('ontouchstart' in window);

    let isTouch = 'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch) ||
        navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0;

    let oTrigger = event.currentTarget;

    let sEvent = oTrigger.getAttribute('data-tooltip-event');

    if (isTouch || !sEvent) {
        sEvent = 'click';
    }

    setTimeout(() => {
        const sId = oTrigger.getAttribute('data-tooltip-id');
        const sText = oTrigger.getAttribute('data-tooltip-text');
        const sPlacement = oTrigger.getAttribute('data-tooltip-placement');
        const sStyle = oTrigger.getAttribute('data-tooltip-style');

        if (!sId && !sText) return;

        const aTooltipsDelete = document.querySelectorAll('.js-tooltip-added');
        if (aTooltipsDelete) {
            for (let a = 0; a < aTooltipsDelete.length; a += 1) {
                if (aTooltipsDelete[a]) {
                    aTooltipsDelete[a].remove();
                }
            }
        }

        // Get tooltip if already in the DOM
        oTooltip = document.querySelector(`.tooltip[data-id="${sId}"]`);

        // Duplicate the template tooltip
        // or create the tooltip if it's NOT present in the DOM already
        if (oTooltip) {
            const oTooltipContent = oTooltip.innerHTML;
            oTooltip = document.body.appendChild(oTooltip.cloneNode(true));
            oTooltip.classList.remove('hidden');

        } else {
            oTooltip = document.body.appendChild(document.createElement('div'));
            oTooltip.classList.add('tooltip');
            oTooltip.innerHTML = `
                    ${sText}
                    <div class="tooltip__arrow" x-arrow></div>
                `;
        }

        oTooltip.classList.add('tooltip--simple');

        if (sStyle === 'mobile') {
            oTooltip.classList.add('tooltip--mobile');
        }

        // Init tooltip
        const oPopper = new Popper(oTrigger, oTooltip, {
            placement: (sPlacement) || 'auto',
            modifiers: {
                keepTogether: { enabled: (sStyle !== 'mobile') },
                arrow: { enabled: (sStyle !== 'mobile') }
            },
        });

        // Add class to check for multiple/duplicate tooltips
        oTooltip.classList.add('js-tooltip-added');

        if (sEvent === 'mouseenter') {
            // Add active class to trigger for z-index issue
            oTrigger.classList.add('tooltip--active');

            oTrigger.addEventListener('mouseleave', () => {
                const aTooltips = document.querySelectorAll('.js-tooltip-added');

                for (let a = 0; a < aTooltips.length; a += 1) {
                    if (aTooltips[a]) {
                        aTooltips[a].remove();
                    }
                }

                // Add active class to trigger for z-index issue
                oTrigger.classList.remove('tooltip--active');

                oTooltip = '';

            });
        }

    }, 0);
};

function fTooltip() {

  // Prevent Popper using translate3d to prevent blurry tooltips on IE
  Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

    const aTriggers = document.querySelectorAll('.js-tooltip');

    //let isTouch = ('ontouchstart' in window);

    let isTouch = 'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch) ||
        navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0;

    for (let i = 0; i < aTriggers.length; i += 1) {
        let sEvent = aTriggers[i].getAttribute('data-tooltip-event');

        let sText = aTriggers[i].getAttribute('data-tooltip-text');

        if (!(sEvent === "mouseenter" && !sText)) { 

            if (isTouch) {
                sEvent = 'click';
            }

            var noTouch = aTriggers[i].classList.contains('js-notouch');

            if (!(isTouch && noTouch)) {

                aTriggers[i].removeEventListener((sEvent) || 'click', fCreateTooltip);

                aTriggers[i].addEventListener((sEvent) || 'click', fCreateTooltip);
            }
        } 
  }
}
